import { render } from "./awsElasticsearch.vue?vue&type=template&id=44a8959b"
import script from "./awsElasticsearch.vue?vue&type=script&lang=js"
export * from "./awsElasticsearch.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../dashboard-mellow-embed-clipboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__